// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1-9P5","large":"styles_large__2zXM1"};